import React, { useEffect } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import PropTypes, { number } from "prop-types";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

import { areaEnum, workTypeEnum, areaColor, areaHourlyRatesEnum } from "../../../config/enum";

export default function GeneralInfosOrder({
  numberAff,
  setNumberAff,
  numberDoli,
  setNumberDoli,
  workType,
  setWorkType,
  siteName,
  setSiteName,
  area,
  setArea,
  city,
  setCity,
  areaHourlyRates,
  setAreaHourlyRates,
  edit,
}) {
  useEffect(() => {
    if (!edit && workType && area) {
      setAreaHourlyRates(areaHourlyRatesEnum[workType][area]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit, workType, area]);
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={numberAff}
            onChange={(event) => setNumberAff(event.target.value)}
            required
            variant="standard"
            type="number"
            label="Numéro Affaire Binsa"
            success={numberAff.length >= 1}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            options={workTypeEnum}
            value={workType}
            required
            onChange={(event, newWorkType) => {
              setWorkType(newWorkType);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez le type de travail" variant="standard" />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <Tooltip
            title={
              !workType || !area ? "Veuillez d'abord saisir la zone et le type de travail" : ""
            }
            placement="top"
          >
            <TextField
              disabled={!workType || !area}
              value={areaHourlyRates}
              onChange={(event) => setAreaHourlyRates(event.target.value)}
              variant="standard"
              type="number"
              label="Taux horaire"
              inputProps={{ maxLength: 255 }}
              fullWidth
            />
          </Tooltip>
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            options={areaEnum}
            value={area}
            required
            onChange={(event, newArea) => {
              setArea(newArea);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Choisissez la zone" variant="standard" />
            )}
            renderOption={(props, option) => (
              <MDBox
                component="li"
                {...props}
                style={{ color: areaColor[option], fontWeight: "bold" }}
              >
                {option}
              </MDBox>
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={city}
            onChange={(event) => setCity(event.target.value)}
            variant="standard"
            type="text"
            label="Ville"
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={siteName}
            onChange={(event) => setSiteName(event.target.value)}
            variant="standard"
            type="text"
            label="Nom du chantier"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
